(function () {
  function initProductCatalogue(section) {
    if (!section || section.dataset.productCatalogueReady === 'true') return;

    section.dataset.productCatalogueReady = 'true';

    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-filter-chip]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-product-item]'));
    var loadMoreButton = section.querySelector('[data-load-more]');
    var emptyState = section.querySelector('[data-empty-state]');

    if (!items.length) return;

    var initialCount = Number(section.dataset.initialProducts) || items.length;
    var loadStep = Number(section.dataset.loadMoreStep) || initialCount;

    var visibleCount = initialCount;
    var activeCollection = 'all';

    function matchesCollection(item) {
      if (activeCollection === 'all') return true;

      var collections = (item.dataset.collections || '').split('|').filter(Boolean);
      return collections.indexOf(activeCollection) !== -1;
    }

    function applyFilter(resetVisibleCount) {
      if (resetVisibleCount) {
        visibleCount = initialCount;
      }

      var matchedItems = items.filter(matchesCollection);

      items.forEach(function (item) {
        item.hidden = true;
      });

      matchedItems.forEach(function (item, index) {
        item.hidden = index >= visibleCount;
      });

      if (emptyState) {
        emptyState.hidden = matchedItems.length > 0;
      }

      if (loadMoreButton) {
        loadMoreButton.hidden = matchedItems.length <= visibleCount;
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeCollection = chip.dataset.collection || 'all';

        chips.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');

        applyFilter(true);
      });
    });

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        visibleCount += loadStep;
        applyFilter(false);
      });
    }

    applyFilter(true);
  }

  function initAllProductCatalogues(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-tfg-product-catalogue]');

    sections.forEach(function (section) {
      initProductCatalogue(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllProductCatalogues(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductCatalogues(event.target);
  });
})();